<script setup lang="ts">
import src from '~/assets/images/homepage/promo-rugby.jpg';
</script>

<template>
  <HomeContentCard
    :src
    :alt="$t('homepage.promo_rugby.alt_text')"
    class="pt-xl md:pt-2xl"
  >
    <IadTitle
      tag="p"
      :text="$t(`homepage.promo_rugby.title`)"
    />
    <IadTitle
      class="text-left"
      variant="small"
      :text="$t(`homepage.promo_rugby.description`)"
      tag="p"
    />
    <template #action>
      <IadBtn
        size="large"
        target="_blank"
        variant="outlined"
        href="https://blog.iadfrance.fr/actualites/actualites-iad/iad-fier-partenaire-immobilier-du-top-14/"
        :text="$t(`core.common.to-know-more`)"
      />
    </template>
  </HomeContentCard>
</template>
